const NavBar = () => {
  return (
    <div className="navbar-outter">
      <div className="outBox">
        <div className="app-title">
          
          <h1 className="brand-name">Good Time Design</h1>
          <h3 className="lower">
            a portfolio built in <strong>2025</strong>.
          </h3>
          
        </div>
      </div>
    </div>
  );
};

export default NavBar;
